import React, { useState } from 'react';
import { Spin, Alert } from 'antd';
import { useG306Query } from './hooks/useG306Query';
import QueryParams from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryRequest } from '../../services/g306Api';
import './G306Form.css';

const G306Form: React.FC = () => {
  const { loading, result, queried, noData, runQuery } = useG306Query();

  const [payeeFrom, setPayeeFrom] = useState('');
  const [payeeTo, setPayeeTo] = useState('');
  const [salesFrom, setSalesFrom] = useState('');
  const [salesTo, setSalesTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [shipNoFrom, setShipNoFrom] = useState('');
  const [shipNoTo, setShipNoTo] = useState('');
  const [includeZero, setIncludeZero] = useState(false);
  const [reportType, setReportType] = useState('');

  const handleQuery = () => {
    const req: QueryRequest = {
      payeeFrom: payeeFrom.trim(),
      payeeTo: payeeTo.trim(),
      salesFrom: salesFrom.trim(),
      salesTo: salesTo.trim(),
      dateFrom: dateFrom.trim(),
      dateTo: dateTo.trim(),
      shipNoFrom: shipNoFrom.trim(),
      shipNoTo: shipNoTo.trim(),
      includeZero,
      reportType: reportType.trim(),
    };
    runQuery(req);
  };

  return (
    <Spin spinning={loading}>
      <div className="g306-container max-w-7xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          應收/付交運佣金餘額表 (pwg306f1)
        </h2>

        <QueryParams
          payeeFrom={payeeFrom}
          payeeTo={payeeTo}
          salesFrom={salesFrom}
          salesTo={salesTo}
          dateFrom={dateFrom}
          dateTo={dateTo}
          shipNoFrom={shipNoFrom}
          shipNoTo={shipNoTo}
          includeZero={includeZero}
          reportType={reportType}
          loading={loading}
          onPayeeFromChange={setPayeeFrom}
          onPayeeToChange={setPayeeTo}
          onSalesFromChange={setSalesFrom}
          onSalesToChange={setSalesTo}
          onDateFromChange={setDateFrom}
          onDateToChange={setDateTo}
          onShipNoFromChange={setShipNoFrom}
          onShipNoToChange={setShipNoTo}
          onIncludeZeroChange={setIncludeZero}
          onReportTypeChange={setReportType}
          onQuery={handleQuery}
        />

        {queried && !noData && result && (
          <ResultTable result={result} />
        )}

        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的佣金餘額資料！請確認篩選條件是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default G306Form;
